import { render, staticRenderFns } from "./AdminNotificationAlert.vue?vue&type=template&id=9d4e9fd6&scoped=true"
import script from "./AdminNotificationAlert.vue?vue&type=script&lang=js"
export * from "./AdminNotificationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4e9fd6",
  null
  
)

export default component.exports